import { forwardRef } from 'react';
import useTranslation from 'shared/hooks/useTranslation';
import styled from 'styled-components';
import Image from 'next/image';
import EmailSection from 'modules/sellsPage/v2/EmailSection';

const Wrapper = styled.div`
  align-items: end;
  display: flex;
  height: 21rem;
  margin: 0;
  position: relative;
  overflow: hidden;

  ${({ theme }) => theme.MEDIA.MD} {
    height: 36rem;
  }

  ${({ theme }) => theme.MEDIA.XL} {
    height: 70rem;
  }
`;

const Background = styled.div`
  background: #2fcc59;
  color: white;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  height: 20rem;
  position: relative;
  z-index: 2;

  ${({ theme }) => theme.MEDIA.MD} {
    height: 32rem;
  }

  ${({ theme }) => theme.MEDIA.XL} {
    height: 60rem;
  }
`;

const ContactWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
  background: transparent;
  position: absolute;
  z-index: 1;
  max-width: 80%;

  ${({ theme }) => theme.MEDIA.SM} {
    max-width: 70%;
  }

  ${({ theme }) => theme.MEDIA.MD} {
    max-width: 60%;
    margin-left: 7rem;
  }

  ${({ theme }) => theme.MEDIA.MD} {
    max-width: 50%;
    margin-left: 7rem;
  }
`;

const Header = styled.h3`
  font-weight: 700;
  font-size: 1.6rem;
  letter-spacing: -0.016em;
  line-height: 115%;

  ${({ theme }) => theme.MEDIA.MD} {
    font-size: 2.5rem;
    line-height: 119%;
    letter-spacing: -0.025rem;
  }

  ${({ theme }) => theme.MEDIA.XL} {
    font-size: 4.8rem;
  }
`;

const SubHeader = styled.h4`
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 400;
  line-height: 155%;
  letter-spacing: 0.0167rem;

  ${({ theme }) => theme.MEDIA.MD} {
    font-size: 1.6rem;
    letter-spacing: 0.0333rem;
  }

  ${({ theme }) => theme.MEDIA.XL} {
    font-size: 3.2rem;
  }
`;

const ImageWrapper = styled.div`
  div {
    transform: translateY(-4%);
    height: 110%;
    width: 90%;
    margin-left: 8%;
  }

  ${({ theme }) => theme.MEDIA.MD} {
    div {
      transform: translateY(-9%);
      height: 150%;
      width: 100%;
      margin-left: unset;
    }
  }

  ${({ theme }) => theme.MEDIA.XL} {
    div {
      transform: translateY(-9%);
      height: 170%;
      width: 100%;
    }
  }
`;

const ContactSection = forwardRef<HTMLDivElement>((props, ref) => {
  const { t } = useTranslation('pricingPage');

  return (
    <Wrapper ref={ref}>
      <Background>
        <ContactWrapper>
          <EmailSection customPage="pricing">
            <Header>{t('contactForm.header')}</Header>
            <SubHeader>{t('contactForm.subHeader')}</SubHeader>
            <span />
          </EmailSection>
        </ContactWrapper>
        <ImageWrapper>
          <div>
            <Image
              src="/img/shared/hero.png"
              alt=""
              layout="fill"
              objectFit="contain"
              objectPosition="top right"
              quality={100}
            />
          </div>
        </ImageWrapper>
      </Background>
    </Wrapper>
  );
});

ContactSection.displayName = 'ContactSection';

export default ContactSection;
